import { useMutation } from 'react-query';

import { changeAssignee as mutationFn } from 'api/endPoints/changeAssignee';

export const useMutationChangeAssignee = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    cardId: string | number;
    isVirtual: boolean;
    username: string;
    versionId: number;
}
